<template>
  <div id="search" class="search-container">
    <b-form-input
      size="lg"
      id="input_search"
      type="search"
      placeholder="ค้นหาคอร์สเรียน"
      v-model="searchText"
      class="search_input"
      @keydown.enter.prevent="search"
    />
    <b-icon-search
      class="search-icon"
      @click="search"
    />
  </div>
</template>

<script>
export default {
  props: ["placeholder"],
  name: "Search",
  data() {
    return {
      searchText: null,
    };
  },
  methods: {
    search() {
      this.$emit("search", this.searchText);
    },
  },
};
</script>

<style scoped>
.search-container {
  position: relative;
  margin: 1rem 0;
}


</style>
